export {default} from 'views/AdjustmentsReason/AdjustmentsReason'


// WEBPACK FOOTER //
// ./src/views/Administration/AdjustmentsReason.jsx